<template>
  <div>
    <VueHtml2pdf
      :show-layout="false"
      :float-layout="true"
      :enable-download="
        $browserDetect && $browserDetect.isFirefox ? true : false
      "
      :preview-modal="false"
      :paginate-elements-by-height="1400"
      :filename="
        'Market Report - ' +
          (this.$route.path.includes('sample')
            ? 'sample'
            : this.$route.params.id)
      "
      :pdf-quality="2"
      :manual-pagination="false"
      pdf-format="a4"
      pdf-orientation="landscape"
      pdf-content-width="1150px"
      ref="html2Pdf"
      @beforeDownload="beforeDownload($event)"
      @hasDownloaded="afterDownload($event)"
      @hasGenerated="afterDownload($event)"
    >
      <section slot="pdf-content">
        <div class="pdf_docs report-pdf-file" ref="document">
          <section ref="page1" slot="pdf-content" class="pdf_docs prfl-pdf">
            <div class="banner reprt-bnr page">
              <div class="section_body">
                <img src="/img/pdf_logo.png" alt="" class="company_logo" />
                <h1>Market Report</h1>
                <p class="sub-title-formatting">
                  {{ this.headerData.industry }}[{{
                    parseFloat(this.headerData.bznaics)
                  }}]
                </p>
                <ul>
                  <li>
                    Sector: <span>{{ headerData.sector }}</span>
                  </li>
                  <li>
                    Market Area: <span>{{ headerData.area }}</span>
                  </li>
                  <li v-if="headerData.sales_class">
                    Sales Class:
                    <span>{{ headerData.sales_class }}</span>
                  </li>
                  <li>
                    Release Date:
                    <span>{{ release_display }}</span>
                  </li>
                </ul>
                <div class="bottom_area">
                  <div class="left">
                    <!--<h4>Company Name</h4>
                                        <div class="logo_wpr">
                                            <img src="/img/vivo_Energy.png" alt />
                                            <h3>Vivo Energy Ltd.</h3>
                                        </div>-->
                  </div>
                  <div v-if="this.headerData.developer_name" class="right">
                    <h5>Developed By</h5>
                    <h3>{{ this.headerData.developer_name }}</h3>
                  </div>
                </div>
              </div>
              <div class="banner_footer">
                <!-- <h6>American Author</h6>-->
                <span class="author"><!--Joyce Meyer--> </span>
                <span class="date">{{
                  moment(new Date()).format("MMM Do YYYY")
                }}</span>
              </div>
            </div>
          </section>
          <section ref="page2" slot="pdf-content" class="pdf_docs prfl-pdf">
            <div class="company_info bg-grey page">
              <div class="section_body">
                <ul>
                  <li>
                    <p>About the Data</p>
                    <p>
                      Vestimate-Pro Methodology <br />Market Analysis Values
                      <br />Data Sources <br />KPI Scoring <br />Vestimate Use:
                      Terms and Conditions
                    </p>
                  </li>
                  <li>
                    <h5>Business Value</h5>
                    <p>
                      Your Firm <br />Asset Sale Value <br />Equity Sale Value
                      <br />Key Value Drivers <br />Historial Vestimate Business
                      Values <br />Valuation Drivers <br />Historical Value
                      Trend
                    </p>
                  </li>
                  <li>
                    <h5>Scores</h5>
                    <p>KPI Scores <br />Other Value Indicators</p>
                  </li>
                  <li>
                    <h5>Company Context</h5>
                    <p>History <br />Products and Customers <br />Operations</p>
                  </li>
                  <li>
                    <h5>Market Environment</h5>
                    <p>
                      Industry Market Analysis <br />Industry Market Benchmarks
                      <br />Market Population Demographics <br />Industry Market
                      Context
                    </p>
                  </li>
                  <li>
                    <h5>Financial Analysis</h5>
                    <p>
                      Industry Financial Analysis <br />Percentages
                      <br />Dollars <br />Varience
                    </p>
                  </li>
                  <li>
                    <h5>KPI Details</h5>
                    <p>
                      Summary <br />Cash Flow-Slovency <br />Profitability
                      <br />Efficiency <br />Debt-Risk
                    </p>
                  </li>
                  <li>
                    <h5>Valuation Approach</h5>
                    <p>
                      General <br />Business Value Approaches <br />Industry in
                      Context <br />Ratio Categories <br />Key Performance
                      Indicators
                    </p>
                  </li>
                  <li>
                    <h5>Customize Report</h5>
                    <p>
                      Check to Integrate Content Years <br />Check to Integrate
                      Financial and Market KPIs <br />Check to Integrate Other
                      Value Indicators <br />Client Display (optional)
                    </p>
                  </li>
                  <li>
                    <h5>Customize Report</h5>
                    <p>
                      Manage Inputs <br />Manual Input <br />Income Statement
                      Line Items <br />Balance Sheet Line Items <br />Employment
                      Data
                    </p>
                  </li>
                </ul>
              </div>
              <p class="common_footer footer-formatting">
                Copyright © 2022 Bizminer. All Rights Reserved.
              </p>
            </div>
          </section>

          <section ref="page3" slot="pdf-content" class="pdf_docs prfl-pdf">
            <div class="about_info page">
              <div class="section_body">
                <div class="about_list">
                  <h2>About the Data</h2>
                  <h4>{{ moment(new Date()).format("MMM Do YYYY") }}</h4>
                </div>
                <div class="">
                  <p>
                    Bizminer data is widely accepted for industry analytical
                    work, benchmarking, valuations, forensics and litigation.
                    Bizminer content is accepted in US Tax Court (Bauer vs. IRS:
                    T.C. Memo. 2012-156) and is utilized by state, provincial
                    and national taxing agencies in the US and Canada.
                  </p>
                  <p>
                    Raw data analyzed for Bizminer reports is sourced from an
                    array of the nation's government and private statistical
                    sources. None of these raw data sources creates the final
                    measures reflected in Bizminer industry profiles. In total,
                    Bizminer accesses over a billion sourced data points from 15
                    million business operations for each of its twice annual
                    updates covering a 3-5 year time series. Historical data and
                    Bizminer algorithms are used to inform and test projections
                    for non-reporting firms. Data elements are sourced
                    specifically from:<br /><br />
                  </p>
                </div>
                <div class="list_box">
                  <ul>
                    <li>IRS SOI Corporation Tax Book</li>
                    <li>IRS Statistics of Income</li>
                    <li>US Economic Census</li>
                    <li>US Census Quarterly Financial Reports</li>
                    <li>US Census County Business Patterns</li>
                    <li>
                      Bureau of Labor Statistics Monthly Employment Reports
                    </li>
                    <li>
                      Bureau of Labor Statistics Monthly Unemployment Reports
                    </li>
                    <li>Bureau of Labor Statistics Annual Wage Survey</li>
                    <li>
                      Bureau of Labor Statistics Industry Productivity Reports
                    </li>
                    <li>Bureau of Labor Statistics Price Indices</li>
                    <li>National Agricultural Statistical Service</li>
                    <li>US Census Quarterly Financial Reports</li>
                    <li>US Census Retail Trade Report</li>
                    <li>Data Axle</li>
                    <li>Business Valuation Resources (BVR)</li>
                    <li>Credit Reporting Agencies</li>
                    <li>Business Directories</li>
                    <li>American Community Survey</li>
                  </ul>
                </div>
                <br />
                <p>
                  While 100% firm coverage is desirable for analysis purposes,
                  the greatest value of Bizminer reports rests in discerning
                  patterns of activity, which are reflected in the large samples
                  used to develop our reports. The overall current coverage of
                  the databases surpasses 13 million active business operations
                  at any point in time.<br /><br />
                  As is the case with any databases this large, some errors are
                  inevitable. Some firms are missed and specific information on
                  others is lacking from the database. Not all information
                  received is uniform or complete, resulting in the need to
                  develop projection algorithms for specific industry segments
                  and metrics in some report series. No representation is made
                  as to the accuracy of the databases utilized or the results of
                  subsequent analyses.
                </p>
              </div>
              <p class="common_footer footer-formatting">
                Copyright © 2022 Bizminer. All Rights Reserved.
              </p>
            </div>
          </section>

          <section ref="page4" slot="pdf-content" class="pdf_docs prfl-pdf">
            <div class="competitive_summary_info page">
              <div class="section_body">
                <div class="md-layout">
                  <div
                    class="md-layout-item md-medium-size-100 md-size-100 p-4 section_title"
                  >
                    <h2>Competitive Summary</h2>
                  </div>
                </div>
                <div class="md-card-content">
                  <div class="md-layout pt-4 pb-4">
                    <div class="md-layout-item md-medium-size-100 md-size-50">
                      <!-- <div class="tbl-title"><h4>Competitive Analysis Summary</h4></div> -->
                      <div class="content">
                        <div class="md-layout">
                          <div class="md-layout-item md-size-100 p-0 tbl">
                            <md-table v-model="tableDataAnalysisSummary">
                              <md-table-row
                                slot="md-table-row"
                                slot-scope="{ item }"
                              >
                                <md-table-cell
                                  md-label="Competitive Analysis Summary"
                                  >{{ item.profileYear }}</md-table-cell
                                >
                                <md-table-cell md-label>
                                  {{ item.firms }}
                                </md-table-cell>
                              </md-table-row>
                            </md-table>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="md-layout-item md-medium-size-100 md-size-50">
                      <!--<div class="tbl-title"><h4>Variance from Market Area Industry: </h4></div>-->
                      <div slot="content">
                        <div class="md-layout">
                          <div class="md-layout-item md-size-100 p-0 tbl">
                            <md-table
                              v-model="tableDataVarianceMarketAreaIndustry"
                            >
                              <md-table-row
                                slot="md-table-row"
                                slot-scope="{ item }"
                              >
                                <md-table-cell
                                  md-label="Variance from Market Area Industry:"
                                >
                                  {{ item.profileYear }}
                                </md-table-cell>
                                <md-table-cell md-label>
                                  {{ item.firms }}
                                </md-table-cell>
                              </md-table-row>
                            </md-table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <p class="common_footer footer-formatting">
                Copyright © 2022 Bizminer. All Rights Reserved.
              </p>
            </div>
          </section>

          <section ref="page5" slot="pdf-content" class="pdf_docs prfl-pdf">
            <div class="insight_sec competitor_sec page">
              <div class="section_body">
                <div class="section_title"><h2>Map</h2></div>
                <div class="table_sec mt-4">
                  <div class="competitors_map-header tbl-title">
                    <h4>Industry Locations</h4>
                    <p class="m-0 pt-2">
                      {{ release_display }} Industry Market Area Operations (up
                      to 250 closest in market area)
                    </p>
                  </div>
                  <div class="white-sec-box">
                    <img
                      v-if="mapImage"
                      :src="mapImage"
                      class="map-image"
                      alt="Map"
                    />
                  </div>
                </div>
              </div>
              <p class="common_footer footer-formatting">
                Copyright © 2022 Bizminer. All Rights Reserved.
              </p>
            </div>
          </section>

          <section ref="page6" slot="pdf-content" class="pdf_docs prfl-pdf">
            <div class="competitor_sec page">
              <div class="section_body">
                <div class="competitors_info_table mt-4">
                  <div class="section_title"><h2>Table/Companies</h2></div>
                  <div class="md-layout-item md-size-100 p-0">
                    <div class="tbl-title">
                      <h4>Industry Market Area Operations</h4>
                    </div>
                    <div class="md-layout">
                      <div
                        class="md-layout-item md-medium-size-100 md-size-100 sub_table border-0 p-0"
                      >
                        <md-table
                          v-model="tableDataMarketArea"
                          table-header-color="blue"
                          class="profit-and-loss-table"
                        >
                          <md-table-row
                            slot="md-table-row"
                            slot-scope="{ item }"
                          >
                            <md-table-cell md-label>
                              <div class="md-table-side-label">
                                {{ item.name }}
                              </div>
                            </md-table-cell>
                            <md-table-cell
                              v-for="key in Object.keys(item.firms)"
                              :key="key"
                              :md-label="years[key]"
                              >{{ item.firms[key] }}</md-table-cell
                            >
                          </md-table-row>
                        </md-table>
                      </div>
                    </div>
                  </div>
                  <div class="md-layout">
                    <div
                      class="md-layout-item md-medium-size-100 md-size-60 pl-0"
                    >
                      <div class="md-card-profile">
                        <div class="md-card-content">
                          <div class="tbl-title purple-bg">
                            <h4 class="title m-0">
                              Mar-2021 Industry Market Area
                            </h4>
                          </div>
                          <div class="tbl-wht-box p-4 light_border ">
                            <LineChart
                              v-if="industryMarketAreaChartData"
                              :ycolor="'#000'"
                              :xcolor="'#000'"
                              :categories="industryMarketAreaChartData.labels"
                              :chartdata="industryMarketAreaChartData.series"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      class="md-layout-item md-medium-size-50 md-size-40 pr-0"
                    >
                      <div class="md-card-profile">
                        <div class="md-card-content">
                          <div class="tbl-title purple-bg">
                            <h4>Competitive Market Narrative</h4>
                          </div>
                          <div class="tbl-wht-box p-4 light_border">
                            <p v-if="cmnText">
                              {{ cmnText.market.volume }}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <p class="common_footer footer-formatting">
                Copyright © 2022 Bizminer. All Rights Reserved.
              </p>
            </div>
          </section>

          <section ref="page7" slot="pdf-content" class="pdf_docs prfl-pdf">
            <div class="industry_market_info page">
              <div class="section_body">
                <div class="section_title"><h2>Industry Market</h2></div>

                <div class="industry_market_volume mt-4">
                  <div class="md-layout-item md-size-100 p-0">
                    <div class="tbl-title">
                      <h4 class="title m-0">Industry Market Volume ($)</h4>
                    </div>
                    <div class="md-card-content">
                      <div class="md-layout">
                        <div
                          class="md-layout-item md-medium-size-100 md-size-100 p-0 sub_table p-0 border-0"
                        >
                          <md-table
                            v-model="tableDataMarketVolume"
                            table-header-color="blue"
                            class="profit-and-loss-table"
                          >
                            <md-table-row
                              slot="md-table-row"
                              slot-scope="{ item }"
                            >
                              <md-table-cell class="md-table-side-label">{{
                                item.name
                              }}</md-table-cell>
                              <md-table-cell
                                v-for="key in Object.keys(item.dates)"
                                :key="key"
                                :md-label="years[key]"
                                >{{ item.dates[key] }}</md-table-cell
                              >
                            </md-table-row>
                          </md-table>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="md-layout mt-4">
                    <div
                      class="md-layout-item md-medium-size-100 md-size-60 pl-0"
                    >
                      <div class="md-card-content">
                        <div slot="chartInsideHeader">
                          <div class="tbl-title">
                            <h4 class="title m-0">Industry Market Volume($)</h4>
                          </div>
                        </div>
                        <div class="tbl-wht-box p-4 light_border ">
                          <LineChart
                            v-if="industryMarketVolumeChartData"
                            :ycolor="'#000'"
                            :xcolor="'#000'"
                            :categories="industryMarketVolumeChartData.labels"
                            :chartdata="industryMarketVolumeChartData.series"
                          />
                        </div>
                      </div>
                    </div>
                    <div
                      class="md-layout-item md-medium-size-100 md-size-40 pr-0"
                    >
                      <div class="tbl-title">
                        <h4 class="title m-0">Industry Market Volume($)</h4>
                      </div>
                      <div class="tbl-wht-box p-4 light_border">
                        <p v-if="cmnText">
                          {{ cmnText.market.volume }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <p class="common_footer footer-formatting">
                Copyright © 2022 Bizminer. All Rights Reserved.
              </p>
            </div>
          </section>

          <section ref="page8" slot="pdf-content" class="pdf_docs prfl-pdf">
            <div class="industry_market_info page">
              <div class="section_body">
                <div class="industry_market_Share_volume">
                  <div class="section_title"><h2>Industry Share</h2></div>
                  <div class="md-layout-item md-size-100 mt-4 p-0">
                    <div class="tbl-title">
                      <h4 class="title m-0">Industry Market Share (%)</h4>
                    </div>
                    <div class="md-layout">
                      <div
                        class="md-layout-item md-medium-size-100 md-size-100 p-0 sub_table p-0 border-0"
                      >
                        <md-table
                          v-model="tableDataMarketShare"
                          table-header-color="blue"
                          class="profit-and-loss-table"
                        >
                          <md-table-row
                            slot="md-table-row"
                            slot-scope="{ item }"
                          >
                            <md-table-cell class="md-table-side-label">{{
                              item.name
                            }}</md-table-cell>
                            <md-table-cell
                              v-for="key in Object.keys(item.dates)"
                              :key="key"
                              :md-label="years[key]"
                              >{{ item.dates[key] }}</md-table-cell
                            >
                          </md-table-row>
                        </md-table>
                      </div>
                    </div>
                  </div>
                  <div class="md-layout mt-4">
                    <div
                      class="md-layout-item md-medium-size-100 md-size-60 pl-0"
                    >
                      <div class="tbl-title">
                        <h4 class="title m-0">
                          Mar-2021 Industry Market Share (%)
                        </h4>
                      </div>
                      <div class="tbl-wht-box p-4 light_border">
                        <LineChart
                          v-if="industryMarketShareChartData"
                          :ycolor="'#000'"
                          :xcolor="'#000'"
                          :categories="industryMarketShareChartData.labels"
                          :chartdata="industryMarketShareChartData.series"
                        />
                      </div>
                    </div>
                    <div
                      class="md-layout-item md-medium-size-100 md-size-40 pr-0"
                    >
                      <div class="tbl-title">
                        <h4 class="title m-0">Competitive Market Narrative</h4>
                      </div>
                      <div class="tbl-wht-box border_light">
                        <p v-if="cmnText">
                          {{ cmnText.market.volume }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <p class="common_footer footer-formatting">
                Copyright © 2022 Bizminer. All Rights Reserved.
              </p>
            </div>
          </section>

          <section ref="page9" slot="pdf-content" class="pdf_docs prfl-pdf">
            <div class="industry_market_info page">
              <div class="section_body">
                <div class="annual_sales_info ">
                  <div class="section_title"><h2>Annual Sales</h2></div>
                  <div class="annual_Average_sales_info">
                    <div class="md-card-content">
                      <div class="md-layout">
                        <!--<div class="md-layout-item md-medium-size-100 md-size-100 mt-2 p-0">
                                    <div class="tbl-title">
                                        <h4 class="title m-0">ABC Plumbing Competitive Sales Analysis</h4>
                                    </div>
                                    <div class="tbl-wht-box p-4 light_border">
                                        <p>
                                            ABC Plumbing sales for the 12 months ending
                                            October 2017 were $1,526,355. Company annual
                                            sales have increased by 1.00% in the three
                                            calendar years since 2015.
                                            <br />As of October 2017 company annualized sales
                                            vary from the local industry average by
                                            21.09%.
                                            <br />Variance from the small business bracket
                                            average is higher at 110.28%, while variance
                                            from median site sales is 157.70%. The
                                            variance from median indicates the percentage
                                            level of annual sales relative to median
                                            sales—the level at which the number of
                                            operations above and below is the same.
                                        </p>
                                    </div>
                                </div>-->
                        <div
                          v-if="annualSalesCols"
                          class="md-layout-item md-size-100 mt-4 p-0"
                        >
                          <div class="tbl-title">
                            <h4 class="title m-0">Average Annual Sales ($)</h4>
                          </div>
                          <div class="md-layout">
                            <div
                              class="md-layout-item md-medium-size-100 md-size-100 sub_table mb-4 p-0 border-0"
                            >
                              <md-table
                                v-model="tableDataMarketAnnualSales"
                                table-header-color="blue"
                                class="profit-and-loss-table"
                              >
                                <md-table-row>
                                  <md-table-head></md-table-head>
                                  <md-table-head
                                    v-for="head in annualSalesCols"
                                    :key="head"
                                  >
                                    <div
                                      class="md-table-head-label"
                                      v-html="head"
                                    ></div>
                                  </md-table-head>
                                </md-table-row>

                                <md-table-row
                                  v-for="(item,
                                  index) in tableDataMarketAnnualSales"
                                  :key="index"
                                >
                                  <md-table-cell class="md-table-side-label">{{
                                    item.name
                                  }}</md-table-cell>
                                  <md-table-cell
                                    v-for="key in Object.keys(item.dates)"
                                    :key="key"
                                    >{{
                                      key == 4
                                        ? item.dates[key] + "%"
                                        : item.dates[key]
                                    }}</md-table-cell
                                  >
                                </md-table-row>
                              </md-table>
                            </div>
                          </div>
                        </div>
                        <div
                          class="md-layout-item md-medium-size-100 md-size-60 pl-0"
                        >
                          <div class="md-card-content">
                            <div slot="chartInsideHeader">
                              <div class="tbl-title">
                                <h4 class="title m-0">
                                  {{ release_display }} Average Annual Sales ($)
                                </h4>
                              </div>
                            </div>
                            <div class="tbl-wht-box p-4 light_border ">
                              <BarChart
                                v-if="industryMarketAnnualSalesChartData"
                                :legend="true"
                                :ycolor="'#000000'"
                                :xcolor="'#000000'"
                                :height="'300px'"
                                :categories="
                                  industryMarketAnnualSalesChartData.labels
                                "
                                :chartdata="
                                  industryMarketAnnualSalesChartData.series
                                "
                              />
                            </div>
                          </div>
                        </div>
                        <div
                          class="md-layout-item md-medium-size-100 md-size-40 pr-0"
                        >
                          <div class="tbl-title">
                            <h4 class="title m-0">
                              Competitive Market Narrative
                            </h4>
                          </div>
                          <div class="tbl-wht-box p-4 light_border">
                            <p>
                              What are the average annual sales of all industry
                              sites, small businesses and startups in this
                              market? Median sales are also displayed to avoid
                              distortion of averages by unusually large firms.
                              If you made the necessary inputs, your firm sales
                              are benchmarked.<br /><br />
                              Small business sales represent firms with &lt;25
                              employees. Startup sales are calculated for firms
                              in operation for less than two years.
                              <br /><br />Market volume and average firm sales
                              calculations are developed with firm‐level data
                              which is integrated with BizMiner’s internally
                              generated Sales per Employee projections. SPE data
                              is both industry‐ and location‐specific, and is
                              updated monthly by the application of US Census
                              data and five industry and consumer price and
                              productivity indices from the Bureau of Labor
                              Statistics and other federal agencies.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <p class="common_footer footer-formatting">
                Copyright © 2022 Bizminer. All Rights Reserved.
              </p>
            </div>
          </section>

          <section ref="page10" slot="pdf-content" class="pdf_docs prfl-pdf">
            <div class="industry_market_info page">
              <div class="section_body">
                <div class="annual_sales_rank_info">
                  <div class="section_title mb-4">
                    <h2>Sales Rank</h2>
                  </div>
                  <div class="md-layout">
                    <div class="md-layout-item md-size-100 mb-4 p-0">
                      <div class="tbl-title">
                        <h4 class="title m-0">
                          Annual Sales Rank
                        </h4>
                      </div>

                      <div
                        class="md-layout-item md-medium-size-100 md-size-100 sub_table p-0 border-0"
                      >
                        <md-table
                          v-model="tableDataSalesRank"
                          table-header-color="blue"
                          class="profit-and-loss-table"
                        >
                          <md-table-row>
                            <md-table-head></md-table-head>
                            <md-table-head
                              v-for="head in annualSalesRankCols"
                              :key="head"
                            >
                              <div
                                class="md-table-head-label"
                                v-html="head"
                              ></div>
                            </md-table-head>
                          </md-table-row>

                          <md-table-row
                            v-for="(item, index) in tableDataSalesRank"
                            :key="index"
                          >
                            <md-table-cell class="md-table-side-label">{{
                              item.name
                            }}</md-table-cell>
                            <md-table-cell
                              v-for="key in Object.keys(item.dates)"
                              :key="key"
                              >{{ item.dates[key] }}</md-table-cell
                            >
                          </md-table-row>
                        </md-table>
                      </div>
                    </div>
                    <div
                      class="md-layout-item md-medium-size-100 mt-2 md-size-100 p-0"
                    >
                      <div class="tbl-title">
                        <h4 class="title m-0">
                          {{ release_display }} Average Annual Sales ($)
                        </h4>
                      </div>
                      <div class="tbl-wht-box p-4 light_border ">
                        <LineChartMulti
                          v-if="avarageAnnualSalesChartData"
                          :categories="avarageAnnualSalesChartData.labels"
                          :chartdata="avarageAnnualSalesChartData.series"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <p class="common_footer footer-formatting">
                Copyright © 2022 Bizminer. All Rights Reserved.
              </p>
            </div>
          </section>

          <section ref="page11" slot="pdf-content" class="pdf_docs prfl-pdf">
            <div class="industry_market_info page">
              <div class="section_body">
                <div class="annual_sales_info covidi9_info">
                  <div class="md-layout">
                    <div class="md-layout-item md-size-100 p-0">
                      <div class="section_title"><h2>COVID-19 Impact</h2></div>
                      <div class="md-layout">
                        <div class="md-layout-item md-size-100 mt-2 p-0">
                          <div class="tbl-title">
                            <h4 class="title m-0">
                              Month-to-Month Employment-Sales
                            </h4>
                          </div>
                          <div class="md-layout">
                            <div
                              class="md-layout-item md-medium-size-100 md-size-100 sub_table p-0 border-0"
                            >
                              <md-table
                                v-model="tableDataMarketCovidImpact"
                                table-header-color="blue"
                                class="profit-and-loss-table"
                              >
                                <md-table-row
                                  slot="md-table-row"
                                  slot-scope="{ item }"
                                >
                                  <md-table-cell class="md-table-side-label">{{
                                    item.name
                                  }}</md-table-cell>
                                  <md-table-cell
                                    v-for="key in Object.keys(item.dates)"
                                    :key="key"
                                    :md-label="names[key]"
                                    >{{ item.dates[key] }}</md-table-cell
                                  >
                                </md-table-row>
                              </md-table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <p class="common_footer footer-formatting">
                Copyright © 2022 Bizminer. All Rights Reserved.
              </p>
            </div>
          </section>

          <section ref="page12" slot="pdf-content" class="pdf_docs prfl-pdf">
            <div class="industry_market_info page">
              <div class="section_body">
                <div class="annual_sales_info covidi9_info">
                  <div class="md-layout">
                    <div class="md-layout-item md-size-100 p-0">
                      <div class="section_title"><h2>COVID-19 Impact</h2></div>
                      <div class="md-layout">
                        <div class="md-layout-item md-size-100 mt-2 p-0">
                          <div class="tbl-title">
                            <h4 class="title m-0">% Change from Dec-19</h4>
                          </div>
                          <div class="md-layout">
                            <div
                              class="md-layout-item md-medium-size-100 md-size-100 sub_table p-0 border-0"
                            >
                              <md-table
                                v-model="tableDataMarketCovidImpactChange"
                                table-header-color="blue"
                                class="profit-and-loss-table"
                              >
                                <md-table-row
                                  slot="md-table-row"
                                  slot-scope="{ item }"
                                >
                                  <md-table-cell class="md-table-side-label">{{
                                    item.name
                                  }}</md-table-cell>
                                  <md-table-cell
                                    v-for="key in Object.keys(item.dates)"
                                    :key="key"
                                    :md-label="covidChangeColumns[key]"
                                    >{{ item.dates[key] }}</md-table-cell
                                  >
                                </md-table-row>
                              </md-table>
                            </div>
                          </div>
                        </div>
                        <div
                          class="md-layout-item md-medium-size-100 md-size-100 mt-4 p-0"
                          v-if="covidImpactChangeChartData.length"
                        >
                          <div class="tbl-title">
                            <h4 class="title m-0">
                              Monthly Change Index (Dec-19=1.00)
                            </h4>
                          </div>
                          <div class="tbl-wht-box p-4 light_border ">
                            <BarChart
                              v-if="covidImpactChangeChartData"
                              :categories="covidImpactChangeChartData.labels"
                              :chartdata="covidImpactChangeChartData.series"
                              :legend="true"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <p class="common_footer footer-formatting">
                Copyright © 2022 Bizminer. All Rights Reserved.
              </p>
            </div>
          </section>

          <section ref="page13" slot="pdf-content" class="pdf_docs prfl-pdf">
            <div class="industry_market_info page">
              <div class="annual_sales_info Penetration_info">
                <div class="section_body">
                  <div class=" md-transparent finanical-report-messages">
                    <div class="md-layout">
                      <div class="md-layout-item md-size-100 p-0">
                        <div class="section_title"><h2>Penetration</h2></div>
                        <div class="md-layout">
                          <div class="md-layout-item mt-4 md-size-100 p-0">
                            <div class="tbl-title">
                              <h4 class="title m-0">Market Penetration ($)</h4>
                            </div>
                            <div class="md-layout">
                              <div
                                class="md-layout-item md-medium-size-100 md-size-100 sub_table mb-4 p-0 border-0"
                              >
                                <md-table
                                  v-model="tableDataMarketPenetration"
                                  table-header-color="blue"
                                  class="profit-and-loss-table"
                                >
                                  <md-table-row
                                    slot="md-table-row"
                                    slot-scope="{ item }"
                                  >
                                    <md-table-cell
                                      class="md-table-side-label"
                                      >{{ item.name }}</md-table-cell
                                    >
                                    <md-table-cell
                                      v-for="key in Object.keys(item.dates)"
                                      :key="key"
                                      :md-label="years[key]"
                                      >{{ item.dates[key] }}
                                    </md-table-cell>
                                  </md-table-row>
                                </md-table>
                              </div>
                            </div>
                          </div>
                          <div
                            class="md-layout-item md-medium-size-100 md-size-60 pl-0"
                          >
                            <div class="tbl-title">
                              <h4 class="title m-0">
                                {{ release_display }} Market Penetration
                              </h4>
                            </div>
                            <div class="tbl-wht-box p-4 light_border ">
                              <LineChart
                                v-if="industryMarketAreaChartData"
                                :ycolor="'#000'"
                                :xcolor="'#000'"
                                :categories="industryMarketAreaChartData.labels"
                                :chartdata="industryMarketAreaChartData.series"
                              />
                            </div>
                          </div>
                          <div
                            class="md-layout-item md-medium-size-100 md-size-40 pr-0"
                          >
                            <div class="tbl-title">
                              <h4 class="title m-0">
                                Competitive Market Narrative
                              </h4>
                            </div>
                            <div class="tbl-wht-box p-4 light_border">
                              <p v-if="cmnText">
                                {{ cmnText.penetration }}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <p class="common_footer footer-formatting">
                Copyright © 2022 Bizminer. All Rights Reserved.
              </p>
            </div>
          </section>

          <section ref="page14" slot="pdf-content" class="pdf_docs prfl-pdf">
            <div class="industry_market_info page">
              <div class="annual_sales_info employment_info">
                <div class="section_body">
                  <div class="md-layout">
                    <div class="md-layout-item md-size-100 p-0 mt-4">
                      <div class="section_title"><h2>Employment</h2></div>
                      <div class="md-layout">
                        <div class="md-layout-item md-size-100 mt-4 mb-4 p-0">
                          <div class="tbl-title">
                            <h4 class="title m-0">Industry Employment</h4>
                          </div>
                          <div class="md-layout mt-b">
                            <div
                              class="md-layout-item md-medium-size-100 md-size-100 sub_table p-0 border-0"
                            >
                              <md-table
                                v-model="tableDataMarketEmployment"
                                table-header-color="blue"
                                class="profit-and-loss-table"
                              >
                                <md-table-row
                                  slot="md-table-row"
                                  slot-scope="{ item }"
                                >
                                  <md-table-cell class="md-table-side-label">{{
                                    item.name
                                  }}</md-table-cell>
                                  <md-table-cell
                                    v-for="key in Object.keys(item.dates)"
                                    :key="key"
                                    :md-label="years[key]"
                                    >{{ item.dates[key] }}</md-table-cell
                                  >
                                </md-table-row>
                              </md-table>
                            </div>
                          </div>
                        </div>
                        <div
                          class="md-layout-item md-medium-size-100 md-size-60 pl-0"
                        >
                          <div class="tbl-title">
                            <h4>
                              {{ release_display }} Average Industry Employment
                            </h4>
                          </div>
                          <div class="tbl-wht-box p-4 light_border ">
                            <LineChart
                              v-if="industryEmploymentChartData"
                              :ycolor="'#000'"
                              :xcolor="'#000'"
                              :categories="industryEmploymentChartData.labels"
                              :chartdata="industryEmploymentChartData.series"
                            />
                          </div>
                        </div>
                        <div
                          class="md-layout-item md-medium-size-100 md-size-40 pr-0"
                        >
                          <div class="tbl-title">
                            <h4 class="title m-0">
                              Competitive Market Narrative
                            </h4>
                          </div>
                          <div class="tbl-wht-box p-4 light_border">
                            <p v-if="cmnText">
                              {{ cmnText.employment }}
                            </p>
                          </div>
                          <div class="tbl-title mt-4">
                            <h4 class="title m-0">Employment</h4>
                          </div>
                          <div class="tbl-wht-box p-4 light_border">
                            <p>
                              How steady is industry employment? Does your firm
                              employ more or less than the average in this
                              industry market? This section reports on industry
                              and small business employment. If you input
                              employment history for your firm, it is
                              benchmarked against the averages.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <p class="common_footer footer-formatting">
                Copyright © 2022 Bizminer. All Rights Reserved.
              </p>
            </div>
          </section>

          <section ref="page15" slot="pdf-content" class="pdf_docs prfl-pdf">
            <div class="industry_market_info page">
              <div class="annual_sales_info Sales_emp_Classes_info">
                <div class="section_body">
                  <div class="section_title">
                    <h2>Sales Classes</h2>
                  </div>

                  <div class="md-layout-item md-size-100 p-0 Sales_info mt-2">
                    <div class="md-layout">
                      <div class="md-layout-item md-size-100 p-0">
                        <div class="tbl-title">
                          <h4 class="title m-0">
                            Market Volume by Class ($million)
                          </h4>
                        </div>
                        <div class="md-layout">
                          <div
                            class="md-layout-item md-medium-size-100 md-size-100 sub_table p-0 border-0"
                          >
                            <md-table
                              v-model="tableDataSalesEmpMarketVolume"
                              table-header-color="blue"
                              class="profit-and-loss-table"
                            >
                              <md-table-row
                                slot="md-table-row"
                                slot-scope="{ item }"
                              >
                                <md-table-cell class="md-table-side-label">{{
                                  item.name
                                }}</md-table-cell>
                                <md-table-cell
                                  v-for="key in Object.keys(item.dates)"
                                  :key="key"
                                  :md-label="salesEmpCols[key]"
                                  >{{ item.dates[key] }}
                                </md-table-cell>
                              </md-table-row>
                            </md-table>
                          </div>
                        </div>
                        <div>
                          <div class="tbl-title mt-2">
                            <h4 class="title m-0">
                              Percent Market Volume by Class
                            </h4>
                          </div>
                          <div class="md-layout">
                            <div
                              class="md-layout-item md-medium-size-100 md-size-100 sub_table p-0 border-0"
                            >
                              <md-table
                                v-model="tableDataPercentMarketVolumeClass"
                                table-header-color="blue"
                                class="profit-and-loss-table"
                              >
                                <md-table-row
                                  slot="md-table-row"
                                  slot-scope="{ item }"
                                >
                                  <md-table-cell class="md-table-side-label">{{
                                    item.name
                                  }}</md-table-cell>
                                  <md-table-cell
                                    v-for="key in Object.keys(item.dates)"
                                    :key="key"
                                    :md-label="salesEmpCols[key]"
                                    >{{ item.dates[key] }}
                                  </md-table-cell>
                                </md-table-row>
                              </md-table>
                            </div>
                          </div>
                        </div>
                        <div class="mt-2">
                          <div class="tbl-title">
                            <h4 class="title m-0">
                              Average Sales by Class (000)
                            </h4>
                          </div>
                          <div class="md-layout">
                            <div
                              class="md-layout-item md-medium-size-100 md-size-100 sub_table p-0 border-0"
                            >
                              <md-table
                                v-model="tableDataAverageSalesClass"
                                table-header-color="blue"
                                class="profit-and-loss-table"
                              >
                                <md-table-row
                                  slot="md-table-row"
                                  slot-scope="{ item }"
                                >
                                  <md-table-cell class="md-table-side-label">{{
                                    item.name
                                  }}</md-table-cell>
                                  <md-table-cell
                                    v-for="key in Object.keys(item.dates)"
                                    :key="key"
                                    :md-label="salesEmpCols[key]"
                                    >{{ item.dates[key] }}
                                  </md-table-cell>
                                </md-table-row>
                              </md-table>
                            </div>
                          </div>
                        </div>
                        <div class="mt-2">
                          <div class="tbl-title">
                            <h4 class="title m-0">
                              Competitive Market Narrative
                            </h4>
                          </div>
                          <div class="tbl-wht-box p-4 light_border">
                            <p v-if="cmnText">
                              {{ cmnText.salesEmpClasses }}
                            </p>
                          </div>
                        </div>
                        <div class="mt-2">
                          <div class="tbl-title">
                            <h4 class="title m-0">Sales</h4>
                          </div>
                          <div class="tbl-wht-box p-4 light_border">
                            <p>
                              What is the employment structure in your industry
                              market?<br /><br />
                              The Market Volume by Employment Class table
                              displays the total market sales of industry sites
                              in each bracket. Projected sales of operations for
                              which sales cannot be ascertained (Unknown ) are
                              noted in the column and are based on average
                              industry site sales in the market area.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <p class="common_footer footer-formatting">
                Copyright © 2022 Bizminer. All Rights Reserved.
              </p>
            </div>
          </section>
          <section ref="page16" slot="pdf-content" class="pdf_docs prfl-pdf">
            <div class="industry_market_info page">
              <div class="section_body">
                <div
                  class="md-layout-item md-size-100 mt-4 p-0 employment_info"
                >
                  <div class="section_title">
                    <h2>Employment</h2>
                  </div>
                  <div class="md-layout mt-4">
                    <div class="md-layout-item md-size-100 p-0">
                      <div>
                        <div class="tbl-title">
                          <h4 class="title m-0">Establishments</h4>
                        </div>
                        <div class="md-layout">
                          <div
                            class="md-layout-item md-medium-size-100 md-size-100 sub_table p-0 border-0"
                          >
                            <md-table
                              v-model="tableDataEstablishments"
                              table-header-color="blue"
                              class="profit-and-loss-table"
                            >
                              <md-table-row
                                slot="md-table-row"
                                slot-scope="{ item }"
                              >
                                <md-table-cell class="md-table-side-label">{{
                                  item.name
                                }}</md-table-cell>
                                <md-table-cell
                                  v-for="key in Object.keys(item.dates)"
                                  :key="key"
                                  :md-label="salesEmpCols[key]"
                                  >{{ item.dates[key] }}
                                </md-table-cell>
                              </md-table-row>
                            </md-table>
                          </div>
                        </div>
                      </div>
                      <div class="mt-4">
                        <div class="tbl-title">
                          <h4 class="title m-0">Total Employment</h4>
                        </div>
                        <div class="md-layout">
                          <div
                            class="md-layout-item md-medium-size-100 md-size-100 sub_table p-0 border-0"
                          >
                            <md-table
                              v-model="tableDataTotalEmployment"
                              table-header-color="blue"
                              class="profit-and-loss-table"
                            >
                              <md-table-row
                                slot="md-table-row"
                                slot-scope="{ item }"
                              >
                                <md-table-cell class="md-table-side-label">{{
                                  item.name
                                }}</md-table-cell>
                                <md-table-cell
                                  v-for="key in Object.keys(item.dates)"
                                  :key="key"
                                  :md-label="salesEmpCols[key]"
                                  >{{ item.dates[key] }}
                                </md-table-cell>
                              </md-table-row>
                            </md-table>
                          </div>
                        </div>
                      </div>
                      <div class="mt-4">
                        <div class="tbl-title">
                          <h4 class="title m-0">Average Employment</h4>
                        </div>
                        <div class="md-layout">
                          <div
                            class="md-layout-item md-medium-size-100 md-size-100 sub_table p-0 border-0"
                          >
                            <md-table
                              v-model="tableDataAverageEmployment"
                              table-header-color="blue"
                              class="profit-and-loss-table"
                            >
                              <md-table-row
                                slot="md-table-row"
                                slot-scope="{ item }"
                              >
                                <md-table-cell class="md-table-side-label">{{
                                  item.name
                                }}</md-table-cell>
                                <md-table-cell
                                  v-for="key in Object.keys(item.dates)"
                                  :key="key"
                                  :md-label="salesEmpCols[key]"
                                  >{{ item.dates[key] }}
                                </md-table-cell>
                              </md-table-row>
                            </md-table>
                          </div>
                        </div>
                      </div>
                      <div class="mt-2">
                        <div class="tbl-title">
                          <h4 class="title m-0">Employment</h4>
                        </div>
                        <div class="tbl-wht-box p-4 light_border">
                          <p>
                            The Establishments by Employment Class table
                            displays the all market area industry operations.
                            Projected employment of operations for which
                            employment cannot be ascertained (Unknown) are based
                            on average industry site employment in the market
                            area.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <p class="common_footer footer-formatting">
                Copyright © 2022 Bizminer. All Rights Reserved.
              </p>
            </div>
          </section>
          <section ref="page17" slot="pdf-content" class="pdf_docs prfl-pdf">
            <div class="annual_sales_info Productivity_info page">
              <div class="section_body">
                <div class="section_title"><h2>Productivity</h2></div>
                <div
                  class="md-layout-item md-size-100 p-0 Productivity_Values_info"
                >
                  <div class="m-0">
                    <h3 class="mt-0 mb-0">Values</h3>
                    <div class="md-layout">
                      <div class="md-layout-item md-size-100 mt-4 p-0">
                        <div>
                          <div class="tbl-title">
                            <h4 class="title m-0">Sales Per Employee ($)</h4>
                          </div>

                          <div class="md-layout">
                            <div
                              class="md-layout-item md-medium-size-100 md-size-100 sub_table p-0 border-0"
                            >
                              <md-table
                                v-model="tableDataSalesPerEmployee"
                                table-header-color="blue"
                                class="profit-and-loss-table"
                              >
                                <md-table-row
                                  slot="md-table-row"
                                  slot-scope="{ item }"
                                >
                                  <md-table-cell class="md-table-side-label">{{
                                    item.name
                                  }}</md-table-cell>
                                  <md-table-cell
                                    v-for="key in Object.keys(item.dates)"
                                    :key="key"
                                    :md-label="years[key]"
                                    >{{ item.dates[key] }}</md-table-cell
                                  >
                                </md-table-row>
                              </md-table>
                            </div>
                          </div>
                        </div>
                        <div class="mt-4">
                          <div class="tbl-title">
                            <h4 class="title m-0">Average Annual Wage ($)</h4>
                          </div>
                          <div class="md-layout">
                            <div
                              class="md-layout-item md-medium-size-100 md-size-100 sub_table border-0 p-0"
                            >
                              <md-table
                                v-model="tableDataAverageAnnualWage"
                                table-header-color="blue"
                                class="profit-and-loss-table"
                              >
                                <md-table-row
                                  slot="md-table-row"
                                  slot-scope="{ item }"
                                >
                                  <md-table-cell class="md-table-side-label">{{
                                    item.name
                                  }}</md-table-cell>
                                  <md-table-cell
                                    v-for="key in Object.keys(item.dates)"
                                    :key="key"
                                    :md-label="years[key]"
                                    >{{ item.dates[key] }}</md-table-cell
                                  >
                                </md-table-row>
                              </md-table>
                            </div>
                          </div>
                        </div>
                        <div class="mt-4">
                          <div class="tbl-title">
                            <h4 class="title m-0">Rent Per Employee ($)</h4>
                          </div>
                          <div class="md-layout">
                            <div
                              class="md-layout-item md-medium-size-100 md-size-100 sub_table p-0 border-0"
                            >
                              <md-table
                                v-model="tableDataRentPerEmployee"
                                table-header-color="blue"
                                class="profit-and-loss-table"
                              >
                                <md-table-row
                                  slot="md-table-row"
                                  slot-scope="{ item }"
                                >
                                  <md-table-cell class="md-table-side-label">{{
                                    item.name
                                  }}</md-table-cell>
                                  <md-table-cell
                                    v-for="key in Object.keys(item.dates)"
                                    :key="key"
                                    :md-label="years[key]"
                                    >{{ item.dates[key] }}</md-table-cell
                                  >
                                </md-table-row>
                              </md-table>
                            </div>
                          </div>
                        </div>
                        <div class="mt-4">
                          <div class="tbl-title">
                            <h4 class="title m-0">
                              Competitive Market Narrative
                            </h4>
                          </div>
                          <div class="tbl-wht-box p-4 light_border">
                            <p v-if="cmnText && cmnText.productivity">
                              {{ cmnText.productivity.valuesTop }}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <p class="common_footer footer-formatting">
                Copyright © 2022 Bizminer. All Rights Reserved.
              </p>
            </div>
          </section>

          <section ref="page18" slot="pdf-content" class="pdf_docs prfl-pdf">
            <div class="annual_sales_info Productivity_info page">
              <div class="section_body">
                <div
                  class="md-layout-item md-size-100 p-0  Productivity_Index_Chart_info"
                >
                  <h3>Index/Chart</h3>
                  <div class="md-layout">
                    <div
                      class="md-layout-item md-medium-size-100 md-size-100 p-0"
                    >
                      <div>
                        <div class="tbl-title">
                          <h4 class="title m-0">
                            ABC Plumbing Competitive Productivity Analysis
                          </h4>
                        </div>
                        <div class="tbl-wht-box p-4 light_border">
                          <p v-if="cmnText && cmnText.productivity">
                            {{ cmnText.productivity.indexTop }}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="md-layout-item md-size-100 mt-4 p-0">
                      <div>
                        <div class="tbl-title">
                          <h4 class="title m-0">Productivity Indices</h4>
                        </div>
                        <div class="md-layout">
                          <div
                            class="md-layout-item md-medium-size-100 md-size-100 p-0"
                          >
                            <md-table
                              v-model="tableDataProductivityIndices"
                              table-header-color="blue"
                              class="profit-and-loss-table"
                            >
                              <md-table-row
                                slot="md-table-row"
                                slot-scope="{ item }"
                              >
                                <md-table-cell class="md-table-side-label">{{
                                  item.name
                                }}</md-table-cell>
                                <md-table-cell
                                  v-for="key in Object.keys(item.dates)"
                                  :key="key"
                                  :md-label="years[key]"
                                  >{{ item.dates[key] }}</md-table-cell
                                >
                              </md-table-row>
                            </md-table>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      class="md-layout-item md-medium-size-100 md-size-60 pl-0 mt-4"
                    >
                      <div>
                        <div class="tbl-title">
                          <h4 class="title m-0">Sales per Employee ($)</h4>
                        </div>
                        <div class="tbl-wht-box p-4 light_border ">
                          <LineChart
                            v-if="salesPerEmployeeChartData"
                            :ycolor="'#000'"
                            :xcolor="'#000'"
                            :height="'250px'"
                            :categories="salesPerEmployeeChartData.labels"
                            :chartdata="salesPerEmployeeChartData.series"
                          />
                        </div>
                      </div>
                    </div>
                    <div
                      class="md-layout-item md-medium-size-100 md-size-40 pr-0 mt-4"
                    >
                      <div>
                        <div class="tbl-title">
                          <h4 class="title m-0">
                            Competitive Market Narrative
                          </h4>
                        </div>
                        <div class="tbl-wht-box p-4 light_border">
                          <p v-if="cmnText && cmnText.productivity">
                            {{ cmnText.productivity.index }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <p class="common_footer footer-formatting">
                Copyright © 2022 Bizminer. All Rights Reserved.
              </p>
            </div>
          </section>
          <section ref="page19" slot="pdf-content" class="pdf_docs prfl-pdf">
            <div class="annual_sales_info Startups_info page">
              <div class="section_body">
                <div
                  class="md-layout-item md-size-100 p-0 Startups_Values_info"
                >
                  <!-- <md-card class="m-0"> -->
                  <div class="section_title"><h2>Startups</h2></div>
                  <!-- <md-card-content> -->
                  <div class="md-layout">
                    <div class="section_title"><h3 class="m-0">Values</h3></div>
                    <div class="md-layout-item md-size-100 p-0">
                      <!-- <md-card> -->

                      <div class="tbl-title">
                        <h4>
                          Startup Performance (Firms)
                        </h4>
                      </div>

                      <!-- <md-card-content> -->
                      <div class="md-layout">
                        <div
                          class="md-layout-item md-medium-size-100 md-size-100 sub_table p-0 border-0"
                        >
                          <md-table
                            v-model="tableDataStartupPerformance"
                            table-header-color="blue"
                            class="profit-and-loss-table"
                          >
                            <md-table-row
                              slot="md-table-row"
                              slot-scope="{ item }"
                            >
                              <md-table-cell class="md-table-side-label">{{
                                item.name
                              }}</md-table-cell>
                              <md-table-cell
                                v-for="key in Object.keys(item.dates)"
                                :key="key"
                                :md-label="years[key]"
                                >{{ item.dates[key] }}</md-table-cell
                              >
                            </md-table-row>
                          </md-table>
                        </div>
                      </div>
                      <!-- </md-card-content> -->
                      <!-- </md-card> -->
                    </div>
                  </div>
                  <div class="md-layout p-0">
                    <div
                      class="md-layout-item md-medium-size-100 md-size-60 pl-0"
                    >
                      <div class="tbl-title">
                        <h4>
                          Industry Startups (2 Years)
                        </h4>
                      </div>
                      <div class="tbl-wht-box p-4 light_border">
                        <LineChart
                          v-if="startupPerformanceChartData"
                          :ycolor="'#000'"
                          :xcolor="'#000'"
                          :categories="startupPerformanceChartData.labels"
                          :chartdata="startupPerformanceChartData.series"
                        />
                      </div>
                    </div>
                    <div
                      class="md-layout-item md-medium-size-100 md-size-40 pr-0"
                    >
                      <div>
                        <div class="tbl-title">
                          <h4>
                            Competitive Market Narrative
                          </h4>
                        </div>
                        <md-card-content>
                          <div class="tbl-wht-box p-4 light_border ">
                            <p v-if="cmnText">
                              {{ cmnText.startups }}
                            </p>
                          </div>
                        </md-card-content>
                      </div>
                    </div>
                  </div>
                  <!-- </md-card-content> -->
                  <!-- </md-card> -->
                </div>
              </div>
              <p class="common_footer footer-formatting">
                Copyright © 2022 Bizminer. All Rights Reserved.
              </p>
            </div>
          </section>

          <section ref="page20" slot="pdf-content" class="pdf_docs prfl-pdf">
            <div class="annual_sales_info Startups_info page">
              <div class="section_body">
                <div
                  class="md-layout-item md-size-100 p-0 Startups_Index_Chart_info"
                >
                  <!-- <md-card class="m-0"> -->
                  <div class="section_title"><h2>Index/Chart</h2></div>
                  <!-- <md-card-content> -->
                  <div class="md-layout">
                    <div class="md-layout-item md-size-100 p-0">
                      <!-- <md-card> -->
                      <div class="tbl-title">
                        <h4>
                          Startup Activity Rates (Firms and Branches)
                        </h4>
                      </div>
                      <!-- <md-card-content> -->
                      <div class="md-layout">
                        <div
                          class="md-layout-item md-medium-size-100 md-size-100 sub_table p-0 border-0"
                        >
                          <md-table
                            v-model="tableDataStartupActivityRates"
                            table-header-color="blue"
                            class="profit-and-loss-table"
                          >
                            <md-table-row
                              slot="md-table-row"
                              slot-scope="{ item }"
                            >
                              <md-table-cell class="md-table-side-label">{{
                                item.name
                              }}</md-table-cell>
                              <md-table-cell
                                v-for="key in Object.keys(item.dates)"
                                :key="key"
                                :md-label="years[key]"
                                >{{ item.dates[key] }}</md-table-cell
                              >
                            </md-table-row>
                          </md-table>
                        </div>
                      </div>
                      <!-- </md-card-content> -->
                      <!-- </md-card> -->
                    </div>
                  </div>
                  <div class="md-layout p-0">
                    <div
                      class="md-layout-item md-medium-size-100 md-size-60 pl-0"
                    >
                      <div class="tbl-title">
                        <h4>
                          Industry Startups (2 Years)
                        </h4>
                      </div>

                      <div class="tbl-wht-box p-4 light_border ">
                        <LineChart
                          v-if="startupActivityChartData"
                          :ycolor="'#000'"
                          :xcolor="'#000'"
                          :categories="startupActivityChartData.labels"
                          :chartdata="startupActivityChartData.series"
                        />
                      </div>
                    </div>
                    <div
                      class="md-layout-item md-medium-size-100 md-size-40 pr-0"
                    >
                      <div class="tbl-title">
                        <h4 class="title m-0">
                          Competitive Market Narrative
                        </h4>
                      </div>
                      <md-card-content>
                        <div class="tbl-wht-box p-4 light_border">
                          <p>
                            How vigorous is industry entrepreneurship in the
                            market area? Defined as operations in business for
                            two years or less, 43 independent industry startups
                            and new branch operations were identified in the
                            market area in October 2017, creating a new
                            operation rate of 6.03% in the most recent analysis
                            year, less than the national rate of 6.06%.
                            Unusually low new operation rates can indicate
                            market saturation or lack of perceived opportunity,
                            while high rates suggest both opportunity and the
                            recognition of it.​
                            <br />
                            <br />Startup rates are calculated by dividing the
                            number of industry market startups by the total
                            number of operations for which an age is known. (Due
                            to the limited number of new operations at any given
                            time, this indicator may be less useful in small
                            local market areas.) ​
                            <br />
                            <br />Industry startup operations hold a 7.68% share
                            of the total local industry market, with average
                            sales of $1,718,359. Due to the variations in scale,
                            startup sales often diverge from the industry and
                            small business average.​
                          </p>
                        </div>
                      </md-card-content>
                    </div>
                  </div>
                  <!-- </md-card-content> -->
                  <!-- </md-card> -->
                </div>
              </div>
              <p class="common_footer footer-formatting">
                Copyright © 2022 Bizminer. All Rights Reserved.
              </p>
            </div>
          </section>

          <section ref="page21" slot="pdf-content" class="pdf_docs prfl-pdf">
            <div class="annual_sales_info Cessation_info page">
              <div class="section_body">
                <div class="md-layout">
                  <div class="md-layout-item md-size-100 p-0">
                    <!-- <md-card> -->
                    <div class="section_title"><h2>Cessation</h2></div>
                    <!-- <md-card-content> -->
                    <div class="md-layout">
                      <div class="md-layout-item md-size-100 p-0">
                        <!-- <md-card> -->
                        <div class="tbl-title">
                          <h4 class="title m-0">
                            2020-2021 Cessation Rates
                          </h4>
                        </div>
                        <!-- <md-card-content> -->
                        <div class="md-layout">
                          <div
                            class="md-layout-item md-medium-size-100 md-size-100 sub_table p-0 border-0"
                          >
                            <md-table
                              v-model="tableDataCessationRates"
                              table-header-color="blue"
                              class="profit-and-loss-table"
                            >
                              <md-table-row
                                slot="md-table-row"
                                slot-scope="{ item }"
                              >
                                <md-table-cell class="md-table-side-label">{{
                                  item.name
                                }}</md-table-cell>
                                <md-table-cell
                                  v-for="key in Object.keys(item.dates)"
                                  :key="key"
                                  :md-label="years[key]"
                                  >{{ item.dates[key] }}</md-table-cell
                                >
                              </md-table-row>
                            </md-table>
                          </div>
                        </div>
                        <!-- </md-card-content> -->

                        <!-- </md-card> -->
                      </div>
                      <div
                        v-if="chartData"
                        class="md-layout-item md-medium-size-100 md-size-50 pl-0"
                      >
                        <div class="tbl-title">
                          <h4>
                            {{ this.chartData.title }}
                          </h4>
                        </div>
                        <div class="tbl-wht-box p-4 light_border ">
                          <BarChart
                            v-if="cessationChartData"
                            :legend="true"
                            :height="'300px'"
                            :ycolor="'#000000'"
                            :xcolor="'#000000'"
                            :categories="cessationChartData.labels"
                            :chartdata="cessationChartData.series"
                          />
                        </div>
                      </div>
                      <div
                        class="md-layout-item md-medium-size-100 md-size-50 pr-0"
                      >
                        <div class="tbl-title">
                          <h4 class="title m-0">
                            Competitive Market Narrative
                          </h4>
                        </div>
                        <md-card-content>
                          <div class="tbl-wht-box p-4 light_border">
                            <p v-if="cmnText">
                              {{ cmnText.cessation }}
                            </p>
                          </div>
                        </md-card-content>
                      </div>
                    </div>
                    <!-- </md-card-content> -->
                    <!-- </md-card> -->
                  </div>
                </div>
              </div>
              <p class="common_footer footer-formatting">
                Copyright © 2022 Bizminer. All Rights Reserved.
              </p>
            </div>
          </section>

          <section ref="page22" slot="pdf-content" class="pdf_docs prfl-pdf">
            <div class="annual_sales_info Ownership_info page">
              <div class="section_body">
                <div class="md-layout Ownership_template">
                  <div class="md-layout-item md-size-100 p-0">
                    <div>
                      <div class="section_title">
                        <h2>Ownership</h2>
                      </div>
                      <div class="md-layout">
                        <div class="md-layout-item mt-4 md-size-100 p-0">
                          <div>
                            <div class="tbl-title">
                              <h4 class="title m-0">
                                Industry Branch Concentration (%)
                              </h4>
                            </div>
                            <!-- <h4 class="title text-left">Industry Branch Concentration (%)</h4> -->
                            <div class="md-layout">
                              <div
                                class="md-layout-item md-medium-size-100 md-size-100 sub_table p-0 border-0"
                              >
                                <md-table
                                  v-model="tableDataBranchConcentration"
                                  table-header-color="blue"
                                  class="profit-and-loss-table"
                                >
                                  <md-table-row
                                    slot="md-table-row"
                                    slot-scope="{ item }"
                                  >
                                    <md-table-cell
                                      class="md-table-side-label"
                                      >{{ item.name }}</md-table-cell
                                    >
                                    <md-table-cell
                                      v-for="key in Object.keys(item.dates)"
                                      :key="key"
                                      :md-label="years[key]"
                                      >{{ item.dates[key] }}</md-table-cell
                                    >
                                  </md-table-row>
                                </md-table>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          class="md-layout-item md-medium-size-100 md-size-60 mt-4 pl-0"
                        >
                          <div>
                            <div>
                              <div class="tbl-title">
                                <h4>
                                  Industry Branch Concentration (%)
                                </h4>
                              </div>
                              <div class="tbl-wht-box p-4 light_border ">
                                <LineChart
                                  v-if="industryBranchChartData"
                                  :ycolor="'#000'"
                                  :xcolor="'#000'"
                                  :categories="industryBranchChartData.labels"
                                  :chartdata="industryBranchChartData.series"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          class="md-layout-item md-medium-size-100 md-size-40 mt-4 pr-0"
                        >
                          <div>
                            <div class="tbl-title">
                              <h4>Competitive Market Narrative</h4>
                            </div>
                            <div class="tbl-wht-box p-4 light_border">
                              <p v-if="cmnText">
                                {{ cmnText.ownership }}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <p class="common_footer footer-formatting">
                Copyright © 2022 Bizminer. All Rights Reserved.
              </p>
            </div>
          </section>

          <section ref="page23" slot="pdf-content" class="pdf_docs prfl-pdf">
            <div
              v-for="(chunk, i) in demographicsChunks"
              :key="i"
              :class="
                'annual_sales_info Demographics_info ' + (i !== 3 ? 'page' : '')
              "
            >
              <div class="section_body">
                <div class="md-layout template_Demographics">
                  <div>
                    <div v-if="i === 0" class="section_title">
                      <h2>
                        Market Area Demographics - 2020 American Community
                        Survey
                      </h2>
                    </div>
                    <div class="md-layout mt-4 mb-4">
                      <div
                        v-for="(demographics, k) in chunk"
                        :key="k"
                        class="md-layout-item md-medium-size-100 md-size-100 p-0"
                      >
                        <ul
                          class="favorite-list companis-list-tabl competitors-list m-0 p-0"
                          v-if="
                            demographics && Object.values(demographics).length
                          "
                        >
                          <li
                            v-for="(categoryData, category) in demographics"
                            :key="category"
                            class="favorite-list-item map-content p-0 mt-4"
                          >
                            <div class="tbl-title">
                              <h4>{{ category }}</h4>
                            </div>
                            <!-- <div class="md-layout"> -->
                            <div>
                              <md-table
                                v-for="(table, index) in categoryData"
                                :key="index + '_category'"
                                table-header-color="blue"
                                class="collapse_table"
                              >
                                <md-table-row
                                  v-for="(item, name) in table"
                                  :key="name + index + category + '_each'"
                                >
                                  <md-table-cell class="md-table-side-label">{{
                                    name
                                  }}</md-table-cell>
                                  <md-table-cell
                                    v-for="(key, i) in item"
                                    :key="key + i"
                                    >{{ key }}</md-table-cell
                                  >
                                </md-table-row>
                              </md-table>
                            </div>
                            <!-- </div> -->
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <p class="common_footer footer-formatting">
                Copyright © 2022 Bizminer. All Rights Reserved.
              </p>
            </div>
            <div class="annual_sales_info Demographics_info page">
              <div class="section_body">
                <div class="md-layout template_Demographics">
                  <div>
                    <!-- <div class="section_title"><h2>Market Area Demographics</h2>   </div> -->
                    <div class="md-layout mt-4 mb-4">
                      <div
                        class="md-layout-item md-medium-size-100 md-size-100 mt-4 p-0"
                      >
                        <div class="mt-0">
                          <div class="tbl-title">
                            <h4 class="title m-0">
                              Competitive Market Narrative
                            </h4>
                          </div>

                          <div class="tbl-wht-box p-4 light_border">
                            <p v-if="cmnText">
                              {{ cmnText.demographics }}
                            </p>
                          </div>
                        </div>
                      </div>
                      <div
                        class="md-layout-item md-medium-size-100 md-size-100 mt-4 p-0"
                      >
                        <div class="mt-0">
                          <div class="tbl-title">
                            <h4 class="title m-0">Demographics</h4>
                          </div>
                          <div class="tbl-wht-box p-4 light_border">
                            <p>
                              Population demographics are applied from the
                              Census Bureau's American Community Survey. Data
                              for zip-county-metro-state and US markets are
                              applied directly. Demographic totals for
                              radius-based markets are applied at the level of
                              aggregated zip codes which are co-joined to the
                              selected market radius. Elements of this data are
                              also integrated into our Sales per Person and
                              Sales per Household calculations displayed on the
                              Penetration>Table tab.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <p class="common_footer footer-formatting">
                Copyright © 2022 Bizminer. All Rights Reserved.
              </p>
            </div>
          </section>
        </div>
      </section>
    </VueHtml2pdf>
  </div>
</template>
<script>
import VueHtml2pdf from "vue-html2pdf";
import { mapState } from "vuex";
import LineChart from "@/components/LineChart.vue";
import BarChart from "@/components/BarChart.vue";
import LineChartMulti from "@/components/LineChartMulti.vue";
import moment from "moment";
export default {
  components: {
    VueHtml2pdf,
    LineChart,
    BarChart,
    LineChartMulti,
  },
  props: ["headerData", "user", "report"],
  data() {
    return {
      showDialog: false,
      tableDataAnalysisSummary: [],
      tableDataVarianceMarketAreaIndustry: [],
      tableDataMarketAnnualSales: [],
      tableDataSalesRank: [],
      view: "cash-flow-solvency",
      tableDataMarketArea: [],

      colouredLineCompetitorsChart: {
        data: {
          labels: [],
          series: [],
        },
        options: {
          lineSmooth: this.$Chartist.Interpolation.cardinal({
            tension: 10,
          }),
          axisY: {
            showGrid: true,
            offset: 40,
          },
          axisX: {
            showGrid: false,
          },
          low: 0,
          showPoint: true,
          height: "300px",
        },
      },
      tableData: [],

      marketVolumeChart: {
        data: {
          labels: [],
          series: [],
        },
        options: {
          lineSmooth: this.$Chartist.Interpolation.cardinal({
            tension: 10,
          }),
          axisY: {
            showGrid: true,
            offset: 40,
          },
          axisX: {
            showGrid: false,
          },
          low: 0,
          showPoint: true,
          height: "300px",
        },
      },
      moment: moment,
      marketShareChart: {
        data: {
          labels: [],
          series: [],
        },
        options: {
          layout: {
            padding: {
              left: 200,
              right: 200,
            },
          },
          lineSmooth: this.$Chartist.Interpolation.cardinal({
            tension: 10,
          }),
          axisY: {
            showGrid: true,
            offset: 40,
          },
          axisX: {
            showGrid: false,
          },
          low: 0,
          showPoint: true,
          height: "300px",
        },
      },

      tableDataMarketVolume: [],
      tableDataMarketShare: [],

      tableDataMarketPenetration: [],

      colouredLineChartPenetration: {
        data: {
          labels: [],
          series: [],
        },
        options: {
          lineSmooth: this.$Chartist.Interpolation.cardinal({
            tension: 10,
          }),
          axisY: {
            showGrid: true,
            offset: 40,
          },
          axisX: {
            showGrid: false,
          },
          showPoint: true,
          height: "300px",
        },
      },
      colouredLineChart: {
        data: {
          labels: [],
          series: [],
        },
        options: {
          lineSmooth: this.$Chartist.Interpolation.cardinal({
            tension: 10,
          }),
          axisY: {
            showGrid: true,
            offset: 40,
          },
          axisX: {
            showGrid: false,
          },
          showPoint: true,
          height: "300px",
        },
      },

      tableDataMarketCovidImpact: [],
      tableDataMarketCovidImpactChange: [],
      covidImpactChangeLineChart: {
        data: {
          labels: [],
          series: [],
        },
        options: {
          lineSmooth: this.$Chartist.Interpolation.cardinal({
            tension: 10,
          }),
          axisY: {
            showGrid: true,
            offset: 40,
          },
          axisX: {
            showGrid: false,
          },
          showPoint: true,
          height: "300px",
        },
      },
      names: [],

      tableDataMarketEmployment: [],
      colouredEmploymentLineChart: {
        data: {
          labels: [],
          series: [],
        },
        options: {
          lineSmooth: this.$Chartist.Interpolation.cardinal({
            tension: 10,
          }),
          axisY: {
            showGrid: true,
            offset: 80,
          },
          axisX: {
            showGrid: false,
          },
          low: 0,
          showPoint: true,
          height: "300px",
        },
      },
      tableDataSalesEmpMarketVolume: [],
      tableDataPercentMarketVolumeClass: [],
      tableDataAverageSalesClass: [],
      tableDataEstablishments: [],
      tableDataTotalEmployment: [],
      tableDataAverageEmployment: [],
      covidImpactChangeChartData: [],

      tableDataSalesPerEmployee: [],
      tableDataAverageAnnualWage: [],
      tableDataRentPerEmployee: [],
      tableDataProductivityIndices: [],

      colouredProductivityLineChart: {
        data: {
          labels: [],
          series: [],
        },
        options: {
          lineSmooth: this.$Chartist.Interpolation.cardinal({
            tension: 10,
          }),
          axisY: {
            showGrid: true,
            offset: 80,
          },
          low: 0,
          axisX: {
            showGrid: false,
          },
          showPoint: true,
          height: "300px",
        },
      },
      industryMarketAreaChartData: null,
      industryMarketVolumeChartData: null,
      industryMarketShareChartData: null,
      industryMarketAnnualSalesChartData: null,
      industryEmploymentChartData: null,
      salesPerEmployeeChartData: null,
      startupPerformanceChartData: null,
      startupActivityChartData: null,
      industryBranchChartData: null,
      avarageAnnualSalesChartData: null,

      tableDataStartupPerformance: [],
      tableDataStartupActivityRates: [],

      startupPerformanceLineChart: {
        data: {
          labels: [],
          series: [],
        },
        options: {
          lineSmooth: this.$Chartist.Interpolation.cardinal({
            tension: 10,
          }),
          axisY: {
            showGrid: true,
            offset: 40,
          },
          axisX: {
            showGrid: false,
          },
          showPoint: true,
          height: "300px",
        },
      },
      startupActivityRatesLineChart: {
        data: {
          labels: [],
          series: [],
        },
        options: {
          lineSmooth: this.$Chartist.Interpolation.cardinal({
            tension: 10,
          }),
          axisY: {
            showGrid: true,
            offset: 40,
          },
          axisX: {
            showGrid: false,
          },
          showPoint: true,
          height: "300px",
        },
      },

      tableDataCessationRates: [],

      cessationChartData: null,

      tableDataBranchConcentration: [],
      colouredLineWonershipChart: {
        data: {
          labels: [],
          series: [],
        },
        options: {
          lineSmooth: this.$Chartist.Interpolation.cardinal({
            tension: 10,
          }),
          axisY: {
            showGrid: true,
            offset: 40,
          },
          axisX: {
            showGrid: false,
          },
          showPoint: true,
          height: "300px",
        },
      },
      locationsChunks: null,
      demographicsChunks: null,
    };
  },
  mounted() {
    this.init();
  },
  watch: {
    headerInfo() {},
    report(newVal, oldVal) {
      this.init();
    },
  },
  computed: {
    ...mapState({
      cmn: (state) =>
        state?.user?.market_report["data"]
          ? state?.user?.market_report["data"]["cmn"]
          : {},
      locations: (state) =>
        state?.user?.market_report?.data &&
        state.user.market_report.data["mapDataVestimate"]
          ? state.user.market_report.data["mapDataVestimate"].filter(
              (x) => x.lat !== null && x.lng !== null
            )
          : null,
      mapData: (state) =>
        state?.user?.market_report?.data
          ? state?.user?.market_report?.data["mapData"]["real-time"][
              "map_data"
            ]["data"]
          : null,
      mapCenter: (state) =>
        state?.user?.market_report?.data["mapData"]["real-time"]["map_center"][
          "data"
        ],
      mapImage: (state) => state?.user?.market_report?.mapImage,
      years: (state) => state?.user?.market_report?.data["years"],
      competitors: (state) =>
        state?.user?.market_report?.data?.data["competitors"],
      release_display: (state) =>
        state?.user?.market_report?.data?.general["release_display"],
      marketVolume: (state) =>
        state?.user?.market_report?.data?.data["marketVolume"],
      marketShare: (state) =>
        state?.user?.market_report?.data?.data["marketShare"],
      years: (state) => state?.user?.market_report?.data?.years,

      annualSales: (state) =>
        state?.user?.market_report?.data?.data["annualSales"],
      annualSalesCols: (state) =>
        state?.user?.market_report?.data
          ? state?.user?.market_report?.data["annualSalesCols"]
          : null,
      annualSalesRank: (state) =>
        state?.user?.market_report?.data?.data
          ? state?.user?.market_report?.data.data["annualSalesRank"]
          : null,
      annualSalesRankCols: (state) =>
        state?.user?.market_report?.data
          ? state?.user?.market_report?.data["annualSalesRankCols"]
          : null,
      penetration: (state) =>
        state?.user?.market_report?.data?.data["penetration"],

      covid: (state) => state?.user?.market_report?.data?.data["covid"],
      covidColumns: (state) =>
        state?.user?.market_report?.data?.data["covidColumns"],
      covidChange: (state) =>
        state?.user?.market_report?.data?.data["covidChange"],
      covidChangeColumns: (state) =>
        state?.user?.market_report?.data?.data["covidChangeColumns"],
      employment: (state) =>
        state?.user?.market_report?.data?.data["employment"],

      salesEmpSales: (state) =>
        state?.user?.market_report?.data?.data["salesEmpSales"],
      salesEmpCols: (state) => state?.user?.market_report?.data["salesEmpCols"],
      salesEmpEmployment: (state) =>
        state?.user?.market_report?.data?.data["salesEmpEmployment"],
      productivityValues: (state) =>
        state?.user?.market_report?.data?.data["productivityValues"],
      productivityIndex: (state) =>
        state?.user?.market_report?.data?.data["productivityIndex"],

      startupsValues: (state) =>
        state?.user?.market_report?.data?.data["startupsValues"],
      startupsIndex: (state) =>
        state?.user?.market_report?.data?.data["startupsIndex"],
      cessation: (state) => state?.user?.market_report?.data?.data["cessation"],
      chartData: (state) =>
        state?.user?.market_report?.data?.charts?.test["Cessation"][0],
      ownership: (state) => state?.user?.market_report?.data?.data["ownership"],
      demographics: (state) =>
        state?.user?.market_report?.data?.data["demographics"],
      cmnText: (state) => state?.user?.market_report?.cmnText,
    }),
    average() {
      if (this.cmn.user_sales_variance > 0) {
        return "greater than average";
      } else if (this.cmn.user_sales_variance < 0) {
        return "greater than average";
      } else {
        return "";
      }
    },
    // enableDownload() {
    //     return true;
    // }
  },
  methods: {
    generateReport() {
      this.$refs.html2Pdf.generatePdf();
    },
    onProgress($e) {},
    async beforeDownload({ html2pdf, options, pdfContent }) {
      this.pdfLoading = true;

      this.$store.commit("user/SET_PDF_LOADING", true);

      let page1 = this.$refs.page1;
      let page2 = this.$refs.page2;
      let page3 = this.$refs.page3;
      let page4 = this.$refs.page4;
      let page5 = this.$refs.page5;
      let page6 = this.$refs.page6;
      let page7 = this.$refs.page7;
      let page8 = this.$refs.page8;
      let page9 = this.$refs.page9;
      let page10 = this.$refs.page10;
      let page11 = this.$refs.page11;
      let page12 = this.$refs.page12;
      let page13 = this.$refs.page13;
      let page14 = this.$refs.page14;
      let page15 = this.$refs.page15;
      let page16 = this.$refs.page16;
      let page17 = this.$refs.page17;
      let page18 = this.$refs.page18;
      let page19 = this.$refs.page19;
      let page20 = this.$refs.page20;
      let page21 = this.$refs.page21;
      let page22 = this.$refs.page22;
      let page23 = this.$refs.page23;

      let pages = [page1, page2, page3, page4, page5];

      this.locationsChunks.forEach((chunk, index) => {
        if (this.$refs["locationChunk" + index]) {
          pages.push(this.$refs["locationChunk" + index][0]);
        }
      });

      pages.push(page6);
      pages.push(page7);
      pages.push(page8);
      pages.push(page9);
      pages.push(page10);
      pages.push(page11);
      pages.push(page12);
      pages.push(page13);
      pages.push(page14);
      pages.push(page15);
      pages.push(page16);
      pages.push(page17);
      pages.push(page18);
      pages.push(page19);
      pages.push(page20);
      pages.push(page21);
      pages.push(page22);
      pages.push(page23);

      options.pagebreak = { avoid: "ul", mode: "css", after: ".br-after" };
      var worker = html2pdf()
        .set(options)
        .from(pages[0])
        .toPdf();
      pages.slice(1).forEach(function(page) {
        worker = worker
          .get("pdf")
          .then(function(pdf) {
            pdf.addPage();
          })
          .from(page)
          .toContainer()
          .toCanvas()
          .toPdf();
      });
      worker.get("pdf").then((pdf) => {
        if (this.$store.getters["user/pdfMustBeDownloaded"]) worker.save();
        else window.open(pdf.output("bloburl"), "_blank");
      });
    },
    async afterDownload() {
      this.pdfLoading = false;
      this.$store.commit("user/SET_PDF_LOADING", false);
    },
    init() {
      if (this.annualSalesRank) {
        this.tableDataSalesRank = Object.entries(this.annualSalesRank).map(
          ([table, data]) => ({
            name: table,
            dates: Object.values(data),
          })
        );

        this.tableDataAnalysisSummary.push(
          {
            profileYear: "Sales Rank:",
            firms: this.tableDataSalesRank[0].dates[1],
          },
          {
            profileYear: "Sales Percentile:",
            firms: this.tableDataSalesRank[1].dates[1],
          },
          {
            profileYear:
              "Sales Change (" +
              this.cmn.release_year1 +
              " to " +
              this.cmn.release_year3 +
              "):",
            firms: this.tableDataSalesRank[2].dates[1],
          }
        );
      }

      if (this.tableDataVarianceMarketAreaIndustry) {
        this.tableDataVarianceMarketAreaIndustry.push(
          {
            profileYear: "Average Site Sales:",
            firms: this.cmn.variance_avg_site,
          },
          {
            profileYear: "Median Site Sales:",
            firms: this.cmn.variance_median_site,
          },
          {
            profileYear: "Average Small Business Sales:",
            firms: this.cmn.variance_sb,
          },
          {
            profileYear: "Average Industry Wage:",
            firms: this.cmn.variance_wage,
          },
          {
            profileYear: "Sales per Employee:",
            firms: this.cmn.variance_spe,
          },
          {
            profileYear: "Efficiency Index (SPE/Avg. Wage):",
            firms: this.cmn.efficiency_index,
          },
          {
            profileYear: "Rent per Employee:",
            firms: this.cmn.variance_rent,
          }
        );
      }

      if (this.competitors) {
        this.tableDataMarketArea = Object.entries(
          this.competitors
        ).map(([table, data]) => ({ name: table, firms: Object.values(data) }));
        this.industryMarketAreaChartData = {
          labels: this.years,
          series: this.tableDataMarketArea.map((item) => ({
            name: item.name,
            data: item.firms,
          })),
        };

        // this.industrySummaryChart = {
        //     labels: filtered_years,
        //     series: [{name: 'Firms', data: seriesFilter}],
        // }

        // this.colouredLineCompetitorsChart.data = {
        //     labels: this.years,
        //     series: this.tableDataMarketArea.map((item) => ({
        //         name: item.name,
        //         data: item.firms,
        //     })),
        // };
      }

      // let section = this.$route.query.section;

      // if (!section) {
      // section = 'cash-flow-solvency';
      // }

      let me = this;
      // this.switchView(section);

      if (this.marketVolume) {
        this.tableDataMarketVolume = Object.entries(
          this.marketVolume
        ).map(([table, data]) => ({ name: table, dates: Object.values(data) }));
        this.tableDataMarketShare = Object.entries(
          this.marketShare
        ).map(([table, data]) => ({ name: table, dates: Object.values(data) }));

        this.tableDataMarketVolume.map((item) => {
          item.dates = item.dates.map((e) => {
            return me.numberWithCommas(e);
          });
          return item;
        });
        let newTableMarketVolume = Object.entries(
          this.marketVolume
        ).map(([table, data]) => ({ name: table, dates: Object.values(data) }));
        let newTableMarketShare = Object.entries(
          this.marketShare
        ).map(([table, data]) => ({ name: table, dates: Object.values(data) }));
        newTableMarketVolume.map((item) => {
          item.dates = item.dates.map((e) => {
            // e = Number(e) / 1000000;
            me.numberWithCommas(e);
            return e;
          });
          return item;
        });
        // this.marketVolumeChart.data = {
        //     labels: this.years,
        //     series: newTableMarketVolume.map((item) => ({
        //     name: item.name,
        //     data: item.dates,
        //     })),
        // };
        this.industryMarketVolumeChartData = {
          labels: this.years,
          series: newTableMarketVolume.map((item) => ({
            name: item.name,
            data: item.dates,
          })),
        };
        // this.marketShareChart.data = {
        //     labels: this.years,
        //     series: newTableMarketShare.map((item) => ({
        //     name: item.name,
        //     data: item.dates.map((i) => Number(i)),
        //     })),
        // };
        this.industryMarketShareChartData = {
          labels: this.years,
          series: newTableMarketShare.map((item) => ({
            name: item.name,
            data: item.dates.map((i) => Number(i)),
          })),
        };
      }

      if (this.annualSales && me) {
        this.tableDataMarketAnnualSales = Object.entries(this.annualSales).map(
          ([table, data]) => ({
            name: table,
            dates: Object.values(data),
          })
        );
        // let me = this;
        this.tableDataMarketAnnualSales.map((item) => {
          item.dates = item.dates.map((e) => {
            return me.numberWithCommas(e);
          });
          return item;
        });
      }

      if (this.annualSalesRank) {
        this.tableDataSalesRank = Object.entries(this.annualSalesRank).map(
          ([table, data]) => ({
            name: table,
            dates: Object.values(data),
          })
        );
      }

      if (this.annualSales) {
        let newChartAnnualSales = Object.entries(this.annualSales).map(
          ([table, data]) => ({
            name: table,
            dates: Object.values(data).slice(0, -1),
          })
        );

        this.industryMarketAnnualSalesChartData = {
          labels: this.years,
          series: newChartAnnualSales.map((item) => ({
            name: item.name,
            data: item.dates,
          })),
        };
      }

      if (this.annualSales) {
        let newTableAnnualSales = Object.entries(this.annualSales).map(
          ([table, data]) => ({
            name: table,
            dates: Object.values(data),
          })
        );
        newTableAnnualSales.map((item) => {
          item.dates = item.dates.map((e) => {
            return Math.round(Number(e)) / 1000000;
          });
          return item;
        });

        this.avarageAnnualSalesChartData = {
          labels: this.years,
          series: newTableAnnualSales.map((item) => ({
            name: item.name,
            data: item.dates.slice(0, -1),
          })),
        };
      }

      if (this.penetration && me) {
        this.tableDataMarketPenetration = Object.entries(
          this.penetration
        ).map(([table, data]) => ({ name: table, dates: Object.values(data) }));
        //let me = this;
        this.tableDataMarketPenetration.map((item) => {
          item.dates = item.dates.map((e) => {
            return me.numberWithCommas(e);
          });
          return item;
        });
        let newTableMarketPenetration = Object.entries(
          this.penetration
        ).map(([table, data]) => ({ name: table, dates: Object.values(data) }));
        newTableMarketPenetration.map((item) => {
          item.dates = item.dates.map((e) => {
            return Number(e);
          });
          return item;
        });
        this.colouredLineChartPenetration.data = {
          labels: this.years,
          series: newTableMarketPenetration.map((item) => ({
            name: item.name,
            data: item.dates,
          })),
        };
      }

      if (this.covidColumns && this.covid) {
        /**** Covid 19 */
        this.tableDataMarketCovidImpact = this.covidColumns.map(
          (name, index) => ({
            name,
            dates: Object.values(this.covid).map((item) => item[index]),
          })
        );
        this.names = Object.keys(this.covid);
        this.tableDataMarketCovidImpactChange = Object.entries(
          this.covidChange
        ).map(([table, data]) => ({ name: table, dates: Object.values(data) }));
        // this.covidImpactChangeLineChart.data = {
        //     labels: this.covidChangeColumns,
        //     series: this.tableDataMarketCovidImpactChange.map((item) => ({
        //     name: item.name,
        //     data: item.dates.map((i) => Number(i.replace('%', ''))),
        //     })),
        // };

        this.covidChangeColumns.shift();
        this.covidImpactChangeChartData = {
          labels: this.covidChangeColumns,
          series: this.tableDataMarketCovidImpactChange.map((item) => {
            if (item.dates) {
              item.dates.shift();
            }
            return {
              name: item.name,
              data: item.dates.map((i) => Number(i ? i.replace("%", "") : "")),
            };
          }),
        };
      }

      if (this.employment && me) {
        /***************Employment********* */
        this.tableDataMarketEmployment = Object.entries(
          this.employment
        ).map(([table, data]) => ({ name: table, dates: Object.values(data) }));
        this.tableDataMarketEmployment.map((item) => {
          item.dates = item.dates.map((e) => {
            return me.numberWithCommas(e);
          });
          return item;
        });
        let newTableMarketEmployment = Object.entries(
          this.employment
        ).map(([table, data]) => ({ name: table, dates: Object.values(data) }));
        newTableMarketEmployment.map((item) => {
          item.dates = item.dates.map((e) => {
            return Number(e);
          });
          return item;
        });
        // this.colouredEmploymentLineChart.data = {
        //     labels: this.years,
        //     series: newTableMarketEmployment.map((item) => ({
        //     name: item.name,
        //     data: item.dates,
        //     })),
        // };

        this.industryEmploymentChartData = {
          labels: this.years,
          series: newTableMarketEmployment.map((item) => ({
            name: item.name,
            data: item.dates,
          })),
        };
      }

      if (this.salesEmpSales) {
        /***************Salse EMP Employment********* */
        this.tableDataAverageSalesClass = Object.entries(
          this.salesEmpSales.avgSales
        ).map(([name, data]) => ({ name, dates: data }));
        this.tableDataSalesEmpMarketVolume = Object.entries(
          this.salesEmpSales.marketVolume
        ).map(([name, data]) => ({ name, dates: data }));
        this.tableDataPercentMarketVolumeClass = Object.entries(
          this.salesEmpSales.percentMarket
        ).map(([name, data]) => ({ name, dates: data }));

        this.tableDataAverageEmployment = Object.entries(
          this.salesEmpEmployment.average
        ).map(([name, data]) => ({ name, dates: data }));
        this.tableDataEstablishments = Object.entries(
          this.salesEmpEmployment.establishments
        ).map(([name, data]) => ({ name, dates: data }));
        this.tableDataTotalEmployment = Object.entries(
          this.salesEmpEmployment.total
        ).map(([name, data]) => ({ name, dates: data }));
      }

      if (this.productivityValues && me) {
        /***************Productivity********* */
        this.tableDataSalesPerEmployee = Object.entries(
          this.productivityValues.spe
        ).map(([name, data]) => ({ name, dates: data }));

        this.tableDataSalesPerEmployee.map((item) => {
          item.dates = item.dates.map((e) => {
            return me.numberWithCommas(e);
          });
          return item;
        });
        this.tableDataAverageAnnualWage = Object.entries(
          this.productivityValues.annualWage
        ).map(([name, data]) => ({ name, dates: data }));
        this.tableDataAverageAnnualWage.map((item) => {
          item.dates = item.dates.map((e) => {
            return me.numberWithCommas(e);
          });
          return item;
        });
        this.tableDataRentPerEmployee = Object.entries(
          this.productivityValues.rent
        ).map(([name, data]) => ({ name, dates: data }));
        this.tableDataRentPerEmployee.map((item) => {
          item.dates = item.dates.map((e) => {
            return me.numberWithCommas(e);
          });
          return item;
        });
      }

      if (this.productivityIndex) {
        this.tableDataProductivityIndices = Object.entries(
          this.productivityIndex
        ).map(([name, data]) => ({ name, dates: data }));
      } else {
        this.tableDataProductivityIndices = [];
      }

      if (this.productivityValues) {
        let newTableRentPerEmployee = Object.entries(
          this.productivityValues.rent
        ).map(([name, data]) => ({ name, dates: data }));
        newTableRentPerEmployee.map((item) => {
          item.dates = item.dates.map((e) => {
            return Number(e);
          });
          return item;
        });
        // this.colouredProductivityLineChart.data = {
        //     labels: this.years,
        //     series: newTableRentPerEmployee.map((item) => ({
        //     name: item.name,
        //     data: item.dates,
        //     })),
        // };

        this.salesPerEmployeeChartData = {
          labels: this.years,
          series: newTableRentPerEmployee.map((item) => ({
            name: item.name,
            data: item.dates,
          })),
        };
      }

      /***************Startups********* */
      if (this.startupsValues && this.startupsIndex && me) {
        this.tableDataStartupPerformance = Object.entries(
          this.startupsValues
        ).map(([table, data]) => ({ name: table, dates: Object.values(data) }));

        this.tableDataStartupActivityRates = Object.entries(
          this.startupsIndex
        ).map(([table, data]) => ({ name: table, dates: Object.values(data) }));

        this.tableDataStartupPerformance.map((item) => {
          item.dates = item.dates.map((e) => {
            return me.numberWithCommas(e);
          });
          return item;
        });
        this.tableDataStartupActivityRates.map((item) => {
          item.dates = item.dates.map((e) => {
            return me.numberWithCommas(e);
          });
          return item;
        });

        // this.startupPerformanceLineChart.data = {
        //     labels: this.years,
        //     series: this.tableDataStartupPerformance.map((item) => ({
        //     name: item.name,
        //     data: item.dates,
        //     })),
        // };
        this.startupPerformanceChartData = {
          labels: this.years,
          series: this.tableDataStartupPerformance.map((item) => ({
            name: item.name,
            data: item.dates,
          })),
        };

        // this.startupActivityRatesLineChart.data = {
        //     labels: this.years,
        //     series: this.tableDataStartupActivityRates.map((item) => ({
        //     name: item.name,
        //     data: item.dates,
        //     })),
        // };

        this.startupActivityChartData = {
          labels: this.years,
          series: this.tableDataStartupActivityRates.map((item) => ({
            name: item.name,
            data: item.dates,
          })),
        };
      }

      if (this.cessation && me) {
        /***************Cessation********* */
        this.tableDataCessationRates = Object.entries(
          this.cessation
        ).map(([table, data]) => ({ name: table, dates: Object.values(data) }));

        this.cessationChartData = {
          labels: this.years,
          series: this.tableDataCessationRates.map((item) => ({
            name: item.name,
            data: item.dates,
          })),
        };

        this.tableDataCessationRates.map((item) => {
          item.dates = item.dates.map((e) => {
            return me.numberWithCommas(e);
          });
          return item;
        });

        // this.pieChart.options.legendNames = Object.entries(
        //     this.chartData.data
        // ).map(([table, index]) => ({ name: table, percentage: index }));
        // this.pieChart.data.series = Object.values(this.chartData.data);
      }

      if (this.ownership) {
        /***************Ownership********* */
        this.tableDataBranchConcentration = Object.entries(
          this.ownership
        ).map(([table, data]) => ({ name: table, dates: Object.values(data) }));

        // this.colouredLineWonershipChart.data = {
        //     labels: this.years,
        //     series: this.tableDataBranchConcentration.map((item) => ({
        //     name: item.name,
        //     data: item.dates.map((i) => Number(i)),
        //     })),
        // };

        this.industryBranchChartData = {
          labels: this.years,
          series: this.tableDataBranchConcentration.map((item) => ({
            name: item.name,
            data: item.dates.map((i) => Number(i)),
          })),
        };
      }

      if (this.locations) this.locationsChunks = this.locations.chunk(20);

      if (this.demographics)
        this.demographicsChunks = Object.entries(this.demographics)
          .map(([k, v]) => ({ [k]: v }))
          .chunk(2);
    },
    numberWithCommas(x) {
      if (x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return x;
      }
    },
    numberWithPoints(x) {
      if (typeof x === "number") {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      } else if (typeof x === "string") {
        return x.replace(/,/g, ".");
      } else {
        return x;
      }
    },
  },
};
</script>
